import firebase from "datastore/database";
import fetchDoc from "util/api/fetchDoc";

export async function add(businessUid, data) {
  return firebase
    .firestore()
    .collection(`visits/business/${businessUid}`)
    .add(data);
}

export const getVisits = async (businessUid, customerUid) => {
  const visitSnap = await firebase
    .firestore()
    .collection(`visits/business/${businessUid}`)
    .where("customerUid", "==", customerUid)
    .get();
  const visits = visitSnap.docs.map((visitDoc) => ({
    uid: visitDoc.id,
    visit: visitDoc.data(),
  }));
  return visits;
};

export async function getVisitsByPhone(businessUid, phoneNumber) {
  const snap = await firebase
    .firestore()
    .collection(`visits/business/${businessUid}`)
    .where("phoneNumber", "==", phoneNumber)
    .get();
  return snap.docs.map((doc) => ({ ...doc.data(), uid: doc.id, businessUid }));
}

export const getVisit = (businessUid, uid) =>
  fetchDoc(`visits/business/${businessUid}/${uid}`);

export const getTotalVisits = async (businessUid) => {
  const snap = await firebase
    .firestore()
    .collection(`meta/business/${businessUid}`)
    .doc("visits")
    .get();
  if (!snap?.exists) return 0;
  return snap?.data()?.count ?? 0;
};

export const getVisitByBookingUid = async (businessUid, bookingUid) => {
  const snap = await firebase
    .firestore()
    .collection(`visits/business/${businessUid}`)
    .where("bookingUid", "==", bookingUid)
    .get();
  if (snap?.empty) return null;
  const data = snap?.docs[0];
  return { ...data?.data(), uid: data?.id };
};
